import Vue from 'vue'

const store = Vue.observable({
    stages: [],
    discountActivations: [],
    discountActivationTemplates: [],
    operators: {},
});

export default store

export function init(values) {
    Object.keys(values).forEach((key) => {
        Vue.set(store, key, values[key])
    })
}
